<script lang="ts">
  import type { OrderOption } from "../../models/order-options.interface";
  import { orderStore } from "../../services/order-options-service";
  import { fileStore } from "../../services/select-files";
  import OptionRow from "./OptionRow.svelte";

  const id = "stations";
  export let option: OrderOption;

  // Default stations
  orderStore.setOrderValue(
    id,
    [...$fileStore.stations.values()].map((tuple) => {
      return {
        id: tuple.id,
        value: tuple.name ? tuple.name : tuple.id,
        selected: true
      };
    })
  );
</script>

<OptionRow
  {id}
  label="Stations"
  tooltip="Edit Stations by closing this modal and deselecting the file. <br /><strong> Note: </strong> Each file contains one station."
>
  {#if $orderStore.options[id]}
    {#each $orderStore.values[id] as option}
      <div>{option.value}</div>
    {/each}
  {/if}
</OptionRow>
